import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { TrailService } from '../services';

export const TrailResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot,
  trailService: TrailService = inject(TrailService)
): Observable<any> => {
  return trailService.initializeTrail(route);
};
